module.exports = __webpack_public_path__ + "../resources/images/illustration_error-1e31504886450152a5dde68ac7a6d0d7.svg";